<div class="camera-permission__header">
  <div class="camera-permission__icon">
    <mat-icon>photo_camera</mat-icon>
  </div>

  <h2 mat-dialog-title class="camera-permission__title">
    {{ 'GLOBALSEARCH.SCANNER.PERMISSION_TITLE' | translate }}
  </h2>
</div>

<mat-dialog-content>
  <p class="camera-permission__text">{{ 'GLOBALSEARCH.SCANNER.PERMISSION_TEXT' | translate }}</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button matButton [mat-dialog-close]="false">{{ 'GLOBALSEARCH.SCANNER.LATER' | translate }}</button>
  <button matButton="filled" [mat-dialog-close]="true" cdkFocusInitial>
    {{ 'GLOBALSEARCH.SCANNER.CONTINUE' | translate }}
  </button>
</mat-dialog-actions>
